import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import { IoIosWarning as WarningIcon } from 'react-icons/io'
import ReEnrollCloseIcon from '../Icons/ReEnrollCloseIcon'
import './styles.scss'

class ReEnrollSignOutErrorPopup extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { isToShowReEnrollSignOutErrorPopup ,handleClose} = this.props
    return (
      <Modal
        show={isToShowReEnrollSignOutErrorPopup}
        className="ReEnroll-Modal rounded-md"
      >
        <Modal.Body className="ReEnroll-Body">
          <div className="row">
            <div className="col-10">
              <p className="ReEnroll-Modal-title">
                {i18nTranslate(
                  'ba_to_member_reenroll_affiliate_member_purchase',
                  'Purchasing is only available by Re-enrolling as a Member or Brand Affiliate. Sign in to Re-enroll.'
                )}
              </p>
            </div>
            <div className="col-2 d-flex justify-content-end">
              <div className="warning-icon">
                <ReEnrollCloseIcon onClose={handleClose} />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ReEnrollSignOutErrorPopup
export { ReEnrollSignOutErrorPopup }
